var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("enable-two-factor-auth")))]),
      _vm.step == 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$ct("download-a-authenticator-app")) +
                          " "
                      ),
                    ]),
                  ]),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-link",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openUrl(
                                "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en"
                              )
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: { fab: "", icon: ["fab", "google-play"] },
                          }),
                          _vm._v(" Google Play "),
                        ],
                        1
                      ),
                      _c(
                        "w-link",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.openUrl(
                                "https://apps.apple.com/us/app/google-authenticator/id388497605"
                              )
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: { fab: "", icon: ["fab", "app-store-ios"] },
                          }),
                          _vm._v(" App Store "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          label: _vm.$ct("enter-password-to-confirm"),
                          disabled: _vm.buttonsDisabled,
                          password: "",
                        },
                        model: {
                          value: _vm.password,
                          callback: function ($$v) {
                            _vm.password = $$v
                          },
                          expression: "password",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.step == 1
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _c("img", {
                      staticClass: "otp-qr",
                      attrs: { src: _vm.imageUrl, alt: "One time password QR" },
                    }),
                  ]),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          label: _vm.$ct("confirm-totp-code"),
                          value: _vm.confirmOtp,
                          "aria-disabled": _vm.buttonsDisabled,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onOtpInput($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.step == 2
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("totp-back-up-codes")) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "w-row",
                _vm._l(_vm.backupCodes, function (code, i) {
                  return _c("w-col", { key: i, attrs: { xs: "6" } }, [
                    _vm._v(" " + _vm._s(code) + " "),
                  ])
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "danger",
              attrs: { disabled: _vm.step == 2 || _vm.buttonsDisabled },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.valid },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.nextButtonText) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }